(function () {
  if (window.newSlideshowAssetLoaded) {
    return;
  }
  window.newSlideshowAssetLoaded = true;

  const WRAPPER_SELECTOR = '[data-new-slideshow-wrapper]';
  const SECTION_ROOT_SELECTOR = '.new-slideshow-wrap';
  const DEFAULT_SLIDE_INTERVAL_MS = 5000;
  const AUTOSLIDE_MIN_BOOT_DELAY_MS = 8000;
  const IDLE_INIT_TIMEOUT_MS = 4000;

  const flickityByWrapper = new WeakMap();
  const abortControllerByWrapper = new WeakMap();

  function clearWrapperTimers(wrapperEl) {
    if (wrapperEl.newSlideshowStartAutoplay) {
      window.removeEventListener('load', wrapperEl.newSlideshowStartAutoplay);
      wrapperEl.newSlideshowStartAutoplay = null;
    }
    if (wrapperEl.newSlideshowStartAutoplayTimer) {
      window.clearTimeout(wrapperEl.newSlideshowStartAutoplayTimer);
      wrapperEl.newSlideshowStartAutoplayTimer = null;
    }
    if (wrapperEl.newSlideshowTimer) {
      window.clearInterval(wrapperEl.newSlideshowTimer);
      wrapperEl.newSlideshowTimer = null;
    }
  }

  function startDeferredAutoplay(flickity, wrapperEl, intervalMs) {
    function scheduleIntervalAfterDelay() {
      wrapperEl.newSlideshowStartAutoplayTimer = window.setTimeout(() => {
        wrapperEl.newSlideshowStartAutoplayTimer = null;
        clearWrapperTimers(wrapperEl);
        wrapperEl.newSlideshowTimer = window.setInterval(() => {
          const len = flickity.slides.length;
          flickity.select((flickity.selectedIndex + 1) % len, false, false);
        }, intervalMs);
      }, Math.max(intervalMs, AUTOSLIDE_MIN_BOOT_DELAY_MS));
    }

    if (document.readyState !== 'complete') {
      wrapperEl.newSlideshowStartAutoplay = () => {
        scheduleIntervalAfterDelay();
        wrapperEl.newSlideshowStartAutoplay = null;
      };
      window.addEventListener('load', wrapperEl.newSlideshowStartAutoplay, { once: true });
    } else {
      scheduleIntervalAfterDelay();
    }
  }

  function getFlickityConstructor() {
    const vendor = window.themeVendor;
    if (!vendor) {
      return null;
    }
    return vendor.FlickityFade || vendor.Flickity || null;
  }

  function bindCustomArrows(wrapperEl, flickity) {
    const sectionRoot = wrapperEl.closest(SECTION_ROOT_SELECTOR);
    if (!sectionRoot) {
      return;
    }

    const prevBtn = sectionRoot.querySelector('[data-prev-arrow]');
    const nextBtn = sectionRoot.querySelector('[data-next-arrow]');
    if (!prevBtn || !nextBtn) {
      return;
    }

    const existing = abortControllerByWrapper.get(wrapperEl);
    if (existing) {
      existing.abort();
    }

    const controller = new AbortController();
    const { signal } = controller;

    prevBtn.addEventListener(
      'click',
      () => {
        const len = flickity.slides.length;
        flickity.select((flickity.selectedIndex - 1 + len) % len, false, false);
      },
      { signal }
    );

    nextBtn.addEventListener(
      'click',
      () => {
        const len = flickity.slides.length;
        flickity.select((flickity.selectedIndex + 1) % len, false, false);
      },
      { signal }
    );

    abortControllerByWrapper.set(wrapperEl, controller);
  }

  function initSlideshows(root) {
    const FlickityCtor = getFlickityConstructor();
    if (!FlickityCtor) {
      return;
    }

    const scope = root || document;
    scope.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapperEl) => {
      if (flickityByWrapper.has(wrapperEl)) {
        return;
      }

      const ds = wrapperEl.dataset;
      const autoplayEnabled = ds.slideshowAutoplay === 'true';
      const showDots = ds.slideshowDots === 'true';
      const showArrows = ds.slideshowArrows === 'true';
      const slideIntervalMs = parseInt(ds.slideshowSpeed, 10) || DEFAULT_SLIDE_INTERVAL_MS;
      const slideCount = parseInt(ds.slideshowSlides, 10) || wrapperEl.children.length;

      const flickity = new FlickityCtor(wrapperEl, {
        adaptiveHeight: true,
        accessibility: true,
        autoPlay: false,
        contain: false,
        draggable: true,
        fade: true,
        pageDots: showDots,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        wrapAround: false,
      });

      if (window.theme && typeof window.theme.bindFlickityAriaHiddenFocusFix === 'function') {
        window.theme.bindFlickityAriaHiddenFocusFix(flickity);
      }

      if (showArrows && slideCount > 1) {
        bindCustomArrows(wrapperEl, flickity);
      }

      if (autoplayEnabled && slideIntervalMs && slideCount > 1) {
        startDeferredAutoplay(flickity, wrapperEl, slideIntervalMs);
      }

      flickityByWrapper.set(wrapperEl, flickity);
    });
  }

  function abortArrowListeners(wrapperEl) {
    const controller = abortControllerByWrapper.get(wrapperEl);
    if (controller) {
      controller.abort();
      abortControllerByWrapper.delete(wrapperEl);
    }
  }

  function destroySlideshows(root) {
    const scope = root || document;
    scope.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapperEl) => {
      abortArrowListeners(wrapperEl);

      const flickity = flickityByWrapper.get(wrapperEl);
      if (flickity) {
        clearWrapperTimers(wrapperEl);
        flickity.destroy();
        flickityByWrapper.delete(wrapperEl);
      }
    });
  }

  function scheduleInit() {
    const run = () => initSlideshows(document);

    function runWhenIdle() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: IDLE_INIT_TIMEOUT_MS });
      } else {
        window.setTimeout(run, 0);
      }
    }

    if (document.readyState === 'complete') {
      runWhenIdle();
      return;
    }

    window.addEventListener(
      'load',
      function () {
        runWhenIdle();
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSlideshows(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySlideshows(event.target);
  });
})();
